/* global  */ // tUrl等のグローバル変数を宣言する

// import gsap from 'gsap' // アニメーションライブラリ
// import ScrollTrigger from 'gsap/ScrollTrigger' // スクロールアニメ

import 'core-js/features/number/is-nan' // SwiperのIE対応
import 'custom-event-polyfill' // SwiperのIE対応
import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言

if (document.getElementById('page-10story')) {
  page10story()
}

function page10story() {
  /*
   ######  ##       #### ########  ########
  ##       ##        ##  ##     ## ##
   ######  ##        ##  ##     ## ######
        ## ##        ##  ##     ## ##
   ######  ######## #### ########  ########
*/
  // MV
  if (document.getElementsByClassName('js-storyMvSlide')[0]) {
    const storyMvSlide = new Swiper('.js-storyMvSlide', {
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      speed: 3000,
      autoplay: {
        delay: 2500,
      },
      loop: true,
      on: {
        init: function () {
          $('.js-storyMvText').addClass('active')
        },
      },
    })
  }
}
